var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCPlusPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 113,
    viewBox: "0 0 100 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.7306 84.4029C99.5146 83.0437 99.9999 81.5137 99.9999 80.1369V32.3976C99.9999 31.0252 99.5154 29.4934 98.7306 28.1343L50.0021 56.2686L98.7306 84.4029Z",
    fill: "#00599C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3306 111.503L95.6715 87.6373C96.8624 86.9494 97.9458 85.762 98.7307 84.4028L50.0021 56.2686L1.26831 84.4028C2.05227 85.762 3.13659 86.9485 4.3275 87.6373L45.6684 111.503C48.0493 112.879 51.9488 112.879 54.3289 111.503H54.3306Z",
    fill: "#004482"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7308 28.1354C97.9459 26.7736 96.8625 25.5862 95.6716 24.9018L54.3298 1.03257C51.9489 -0.344191 48.0503 -0.344191 45.6693 1.03257L4.32849 24.9018C1.94667 26.2742 0 29.6496 0 32.3978V80.1363C0 81.5121 0.484467 83.0431 1.2693 84.4022L50.0014 56.2688L98.7308 28.1354Z",
    fill: "#659AD2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0012 22.9333C31.6205 22.9333 16.6672 37.8874 16.6672 56.2681C16.6672 74.6487 31.6205 89.6029 50.0012 89.6029C61.8618 89.6029 72.9244 83.2194 78.8666 72.9461L64.4427 64.5974C61.4654 69.7415 55.9337 72.9346 50.0012 72.9346C40.8113 72.9346 33.3338 65.458 33.3338 56.2672C33.3338 47.0764 40.8122 39.5998 50.0012 39.5998C55.9293 39.5998 61.4672 42.7964 64.4383 47.937L78.8666 39.5892C72.9208 29.315 61.8618 22.9333 50.0012 22.9333ZM75.9289 50.7108V54.4165H72.2232V58.1187H75.9289V61.8245H79.6311V58.1187H83.3334V54.4165H79.6311V50.7108H75.9289ZM89.8164 50.7108V54.4165H86.1133V58.1187H89.8164V61.8245H93.5221V58.1187H97.2243V54.4165H93.5221V50.7108H89.8164Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCPlusPlus);
export default __webpack_public_path__ + "static/media/CPlusPlus.337622fdfff2f41255c4beb5f30bbe14.svg";
export { ForwardRef as ReactComponent };